import React from 'react'

import { BadgeAccessRender } from '@app/components/renderers'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { SCHEDULE_COLUMN_KEY } from '@app/pages/MonitoringLaunchPage/constants'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap, columnTitleMapSchedule } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ColumnRender } from '@app/types/table'
import type { TotalMonitoringDataSource, TotalMonitoringColumns, TotalMonitoringColumnsSchedule } from '../types'

const getRender = (key: keyof TotalMonitoringColumns): ColumnRender<TotalMonitoringColumns> | undefined => {
  switch (key) {
    case 'isLaunchAccess':
      return function LaunchAccessRender (_, { isLaunchAccess }) {
        return <BadgeAccessRender hasAccess={ isLaunchAccess } />
      }
    default:
      return undefined
  }
}

const getColumnsOptions = (): Array<Column<TotalMonitoringColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof TotalMonitoringColumns>

  return columnKeys.map(key => {
    const column: Column<TotalMonitoringColumns> = {
      customEllipsis: CustomEllipsis,
      key,
      render: getRender(key),
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumnsScheduleOptions = (): Array<Column<TotalMonitoringColumnsSchedule>> => {
  const columnKeys = Object.keys(columnTitleMapSchedule) as Array<keyof TotalMonitoringColumnsSchedule>

  return columnKeys.map(key => {
    const column: Column<TotalMonitoringColumnsSchedule> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<TotalMonitoringDataSource>> =>
  [
    ...getColumnsFromMap<TotalMonitoringColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    }),
    {
      key: SCHEDULE_COLUMN_KEY,
      title: 'Расписание/Дедлайны',
      children: [
        ...getColumnsFromMap<TotalMonitoringColumnsSchedule>({
          columnTitleMap: columnTitleMapSchedule,
          options: getColumnsScheduleOptions()
        })
      ]
    }
  ] as Array<Column<TotalMonitoringDataSource>>
